<div class="touchpoints-page" [class.auto-height]="activeTab === tabs.manage">
  <div *appIsDesktop class="touchpoints-header">
    @if (isAdmin && isOnline) {
      <div class="header-left account-manager-container">
        @if (!accountManagersLoading) {
          <ds-autocomplete
            id="touchpoints-am-search"
            class="no-subscript"
            [label]="appStrings?.quoteDetails_AccountManager"
            label_orientation="vertical-label"
            drop_icon="search"
            [options]="accountManagerOptions"
            [control]="accountManagerCtrl"
            (selectionChange)="onAccountManagerSelected($event)"
            fullFilter="true">
          </ds-autocomplete>
        }
      </div>
    }
    @if (isAccountManager) {
      <div class="header-center">
        <ds-button-toggle-legacy
          [toggleValues]="toggleValues"
          size="large"
          type="outlined"
          [selectedIndex]="activeTab"
          [isMultipleSelection]="false"
          (onClick)="onTabClick($event)">
        </ds-button-toggle-legacy>
      </div>
    }
    <div class="header-right">
      @if (isAccountManager && isOnline) {
        <ds-button
          id="retrySync_button"
          [label]="appStrings?.button_retrySync"
          variant="secondary"
          type="label-only"
          size="large"
          icon="refresh"
          iconPosition="left"
          [isDisabled]="retryingSync"
          (onClick)="retrySync()">
        </ds-button>
      }
      <ds-button
        id="newTouchpoint_button"
        [label]="appStrings?.button_newTouchpoint"
        variant="primary"
        type="label-only"
        size="large"
        (onClick)="openNewTouchpoint()">
      </ds-button>
    </div>
  </div>

  <div *appIsMobile class="mobile touchpoints-header-mobile">
    @if (isAdmin && isOnline) {
      <ds-paper elevation="elevation_none"
        borderRadius="radius_XS" outline="outlined" insidePaddingTop="top-spacing_S"
        insidePaddingBottom="bottom-spacing_S" insidePaddingLeft="left-spacing_S"
        insidePaddingRight="right-spacing_S">
        <div class="mobile-search">
          @if (!accountManagersLoading) {
            <ds-autocomplete
              id="touchpoints-am-search-mobile"
              class="no-subscript"
              [placeholder]="appStrings?.quoteDetails_AccountManager"
              drop_icon="search"
              [options]="accountManagerOptions"
              [control]="accountManagerCtrl"
              (selectionChange)="onAccountManagerSelected($event)"
              fullFilter="true">
            </ds-autocomplete>
          }
          <ds-button class="add-button"
            id="newTouchpointMobile_button"
            shape="square" size="medium" type="primary"
            variant="icon-only" icon="add"
            iconPosition="left" iconStyle="material-icons"
            (onClick)="openNewTouchpoint()">
          </ds-button>
        </div>
      </ds-paper>
    } @else {
      <div class="mobile-header-actions">
        @if (isAccountManager && isOnline) {
          <ds-button
            id="retrySyncMobile_button"
            [label]="appStrings?.button_retrySync"
            type="secondary"
            variant="label-icon"
            size="medium"
            icon="refresh"
            iconPosition="left"
            [isDisabled]="retryingSync"
            (onClick)="retrySync()">
          </ds-button>
        }
        <ds-button
          id="newTouchpointMobile_button"
          [label]="appStrings?.button_newTouchpoint"
          type="primary"
          variant="label-only"
          size="medium"
          (onClick)="openNewTouchpoint()">
        </ds-button>
      </div>
    }
    <typography id="touchpointsMobileTitle" class="mobile-page-title" variant="mat-headline-4" weight="bold">{{ appStrings?.menu_Touchpoints }}</typography>
    @if (isAccountManager) {
      <div class="mobile-header-tabs ellipsis-toggle">
        <ds-button-toggle-legacy
          [toggleValues]="toggleValues"
          size="medium"
          type="outlined"
          [selectedIndex]="activeTab"
          [isMultipleSelection]="false"
          (onClick)="onTabClick($event)">
        </ds-button-toggle-legacy>
      </div>
    }
  </div>

  @if ((isAdmin && isOnline && accountManagersLoading) || retryingSync) {
    <div class="overlay full" id="touchpoints-loadingSpinner">
      <p class="text-center">{{ retryingSync ? appStrings?.outlookSyncInProgress : appStrings?.pleaseWait }}</p>
      <ds-progress-spinner progress_mode="indeterminate"></ds-progress-spinner>
    </div>
  } @else {
    <div class="touchpoints-body">
      @if (activeTab === tabs.calendar) {
      @if (isAdmin && !selectedAccountManagerId) {
        <div class="text-center">
          <p>{{ appStrings?.quoteDetails_AmMissing }}</p>
        </div>
      } @else {
        <div class="calendar-container">
          @if (accountManagersLoading || calendarLoading) {
            <div class="overlay calendar-overlay" id="touchpoints-loadingSpinner">
              <p class="text-center">{{ appStrings?.pleaseWait }}</p>
              <ds-progress-spinner progress_mode="indeterminate"></ds-progress-spinner>
            </div>
          }
          <ds-event-calendar
            [events]="calendarEvents"
            [filterOptions]="calendarFilterOptions"
            [selectedDate]="calendarSelectedDate"
            [view]="calendarView"
            (onClick)="onCalendarEventClick($event)"
            (timeRangeSelected)="onTimeRangeSelected($event)"
            (dateSelected)="onCalendarDateSelected($event)"
            (todayClicked)="onCalendarTodayClicked($event)"
            (periodNavigated)="onCalendarPeriodNavigated($event)"
            (viewChanged)="onCalendarViewChanged($event)"
            (addEventMonthView)="onMonthAddEvent($event)">
          </ds-event-calendar>
        </div>
      }
    }

      @if (activeTab === tabs.manage && isAccountManager && isOnline) {
        <app-manage-contacts-touchpoints></app-manage-contacts-touchpoints>
      }
    </div>
  }
</div>
